import React from 'react';
import db from '../firebase';
import { Link } from 'react-router-dom';
import './create.css';

let variantArray: Array<string>;
let likesArray: Array<number>;
variantArray = [];
likesArray = [];
let i = 0;

document.getElementById("mid-id")?.remove();
document.getElementById("header")?.remove();
document.getElementById("spacer")?.remove();

const addQuestion = () => {
    let questionInp = (document.getElementById("question-ider") as HTMLInputElement).value;
    if(questionInp) {
        //epoch time
        let ephochTime = Math.floor(new Date().getTime()/1000.0);
        //console.log(ephochTime);
        //let myDate = new Date(ephochTime*1000);


        //console.log(myDate.getMinutes());
        db.collection("questions").add({
            question: questionInp,
            variants: {variant: variantArray, likes: likesArray},
            time: ephochTime
        })
        .then(function(docRef) {
            let a = docRef.id;
            //console.log("Document written with ID: ", a);
            (document.getElementById("createLink") as HTMLInputElement).remove();
            (document.getElementById("title") as HTMLInputElement).textContent = "Go to poll - don't forget the code!";
            (document.getElementById("title") as HTMLInputElement).onclick = function() {
                (document.getElementById("map-id") as HTMLInputElement).remove();
            }
            let root = (document.getElementById("root") as HTMLInputElement);

            let map = document.createElement('div') as HTMLDivElement;
            map.id = "map-id";

            let text = document.createElement('div') as HTMLDivElement;
            text.id = 'text';
            text.textContent = "Click to copy code";
            

            let code = document.createElement('div') as HTMLDivElement;
            code.id = 'code';
            code.textContent = a;

            let thank = document.createElement('div') as HTMLDivElement;
            thank.id = 'thank';
            thank.textContent = "Thank you for choosing variantpoll. :)";

            let you = document.createElement('div') as HTMLDivElement;
            you.id = 'thank';
            you.textContent = "This is you 💎";

            let share = document.createElement('div') as HTMLDivElement;
            share.id = 'text';
            share.textContent = "Give this code to the people you want to share ideas with.";

            //copy to clipboard
            code.onclick = function() {
                navigator.clipboard.writeText(a);
                text.textContent = "Copied!";
                window.location.href = '/';
            }

            map.appendChild(thank);
            map.appendChild(you);
            map.appendChild(text);
            map.appendChild(code);
            //map.appendChild(goThere);
            //map.appendChild(share);
            root.appendChild(map);
        })
    }
    else {
        (document.getElementById("question-ider") as HTMLInputElement).style.backgroundColor = "rgba(238, 18, 18, 0.342)";
    }
}

const addVariant = () => {
    updateTotalNumber();
    if((document.getElementById("inp-add-variant") as HTMLInputElement).value) {
        variantArray[i] = (document.getElementById("inp-add-variant") as HTMLInputElement).value;
        likesArray[i] = 0;
        i++;
        //console.log(variantArray);
        let el = document.createElement('div') as HTMLDivElement;
        el.className = "fixed-variants";
        el.textContent = variantArray[i-1];

        let parent = (document.getElementById("the-variants") as HTMLInputElement);
        parent.appendChild(el);

        (document.getElementById("inp-add-variant") as HTMLInputElement).value = "";
        let btn = (document.getElementById("createLink") as HTMLInputElement);
        btn.style.pointerEvents = "all";
        btn.style.color = "rgb(153, 68, 233)";
    }
}

const handleKeyDown = (event: { key: string; }) => {
  if (event.key === 'Enter') {
    addVariant();
  }
}

function updateTotalNumber() {
    let total = 0;

    db.collection("total").doc("total-number")
  .get()
  .then(function(doc) {
    if (doc.exists) {
        total = doc.data()!.nr;
        total++;
        //doc.data()!.nr);
        //console.log(total);

        db.collection("total").doc("total-number").update({
            nr: total
        })

    } else {
      // doc.data() will be undefined in this case
      //console.log("No such document!");
    }
    }).catch(function(error) {
        //console.log("Error getting document:", error);
    });

}

function Create() {
    return (
    <div id='the'>
        <div className='question-block' id='ques'>
        <Link className='btn' id='title' to="/">variantpoll</Link>
            <div id='tinere'>
                <textarea spellCheck="false" className='inp' placeholder='Write question here' cols={40} rows={5} id='question-ider'></textarea>
                <div id='tine'>
                    <input type="text" placeholder='Enter variant here' autoComplete='off' spellCheck={false} onKeyDown={handleKeyDown} className='inp-add-variantt' id='inp-add-variant'></input>
                    <div onClick={() => addVariant()} id='thebtn'>Enter</div>
                </div>
            </div>
        </div>
        <div className='main-block'>
            <div id='thespacer'>
                <div className='variants-block'>
                   
                </div>
            </div>
            <div className='the-variants' id='the-variants'></div>
            <div className='footer' id='footer'>
                <button className='createLink' id='createLink' onClick={() => {addQuestion()}}>Generate Code</button>
            </div>
        </div>
    </div>
  );
}

export default Create;

